class Page {
  static setTitle(title: string) {
    document.title = title;
  }
}

export default Page;